import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, viewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { CheckoutTouristIn, PackageHotel } from '@appTypes/api.types';
import { TranslatePipe } from '@ngx-translate/core';
import { CheckoutHotelTypedForm, ICheckoutHotelFormValues } from '@pages/checkout-page/checkout.typed-forms';
import { HotelCardComponent } from '@shared/components/hotel-card/hotel-card.component';
import { SelectorComponent } from '@shared/components/selector/selector.component';
import { KzInputDirective } from '@shared/directives/kz-input.directive';
import { TypedTemplateDirective } from '@shared/directives/typed-template.directive';
import { DynamicModalRef, OnDynamicModal } from '@shared/modules/dynamic-modal/dynamic-modal.types';
import { RunFunctionPipe } from '@shared/pipes/run-function.pipe';
import { environment } from '@env/environment';

export interface CheckoutTouristCheckInConfigParams {
  hotel: PackageHotel;
  hotelFormData: ICheckoutHotelFormValues;
  tourists: CheckoutTouristIn[];
}
@Component({
  selector: 'app-checkout-tourist-check-in-config-form',
  templateUrl: './checkout-tourist-check-in-config-form.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    HotelCardComponent,
    NgTemplateOutlet,
    KzInputDirective,
    MatButton,
    TypedTemplateDirective,
    DatePipe,
    TranslatePipe,
    RunFunctionPipe,
    SelectorComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutTouristCheckInConfigFormComponent implements OnDynamicModal {
  readonly modalFooterTemplateRef = viewChild.required<TemplateRef<unknown>>('modalFooterTemplateRef');

  readonly dateFormat = environment.formats.date;

  modalRef!: DynamicModalRef;

  readonly guestsSelectorTemplateTypedToken!: { option: CheckoutTouristIn & { _index: number } };
  readonly formGroup = new FormGroup(new CheckoutHotelTypedForm());
  data!: CheckoutTouristCheckInConfigParams;
  applyIndexesForTouristsFn = () => {
    return this.data.tourists.map((e, index) => ({ ...e, _index: index + 1 }));
  };
  onDynamicModal(data: CheckoutTouristCheckInConfigParams): void {
    this.data = data;
    this.#initData();
  }
  onSubmit() {
    if (this.formGroup.valid) this.modalRef.close(this.formGroup.getRawValue());
    else this.formGroup.markAllAsTouched();
  }
  onGuestSelect(formControl: FormControl, selectedId?: string) {
    if (!formControl) return;
    if (!formControl.value) {
      formControl.setValue(selectedId ?? null);
      return;
    }
    //swapping
    const storedValue = formControl.value;
    const swapControl = this.formGroup.controls.touristIds.controls.find((e) => e.value === selectedId);
    if (swapControl?.value) swapControl.setValue(storedValue);
    formControl.setValue(selectedId ?? null);
  }
  #initData() {
    if (this.data.hotelFormData.touristIds?.length)
      this.data.hotelFormData.touristIds.forEach(() =>
        this.formGroup.controls.touristIds.push(new FormControl(null, Validators.required))
      );
    this.formGroup.patchValue(this.data.hotelFormData);
  }
}
